// extracted by mini-css-extract-plugin
export default {"contactForm":"Contact_contactForm__DP3nH","field":"Contact_field__oqhah","submit":"Contact_submit__mhjLU"};